export default __webpack_public_path__ + "static/media/spot-catlike-final.be9d3300.ogv";